import { getSpacing } from '../../../const/spacing';
export const evaluateSpacingsStyle = ({ $spacing, $spacingHorizontal, $spacingVertical, $spacingTop: $passedSpacingTop, $spacingRight: $passedSpacingRight, $spacingBottom: $passedSpacingBottom, $spacingLeft: $passedSpacingLeft, }) => {
    const spacingTop = $passedSpacingTop ?? $spacingVertical ?? $spacing ?? '0';
    const spacingRight = $passedSpacingRight ?? $spacingHorizontal ?? $spacing ?? '0';
    const spacingBottom = $passedSpacingBottom ?? $spacingVertical ?? $spacing ?? '0';
    const spacingLeft = $passedSpacingLeft ?? $spacingHorizontal ?? $spacing ?? '0';
    return {
        paddingTop: getSpacing(spacingTop),
        paddingRight: getSpacing(spacingRight),
        paddingBottom: getSpacing(spacingBottom),
        paddingLeft: getSpacing(spacingLeft),
    };
};
